import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { baseStyles, rootVariablesStyles, typographyStyles } from '@/styles';

import { iconExclamationTriangle } from '@/components/icons';
import '../../loader/fg-loader';

@customElement('fg-personalisation-error')
export class FgPersonalisationError extends LitElement {
  @property({ type: String })
  errorMessage?: string;

  render() {
    return html`
      <div aria-live="assertive" role="alert">
        <span>${iconExclamationTriangle} ${this.errorMessage}</span>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    typographyStyles,
    rootVariablesStyles,
    css`
      div {
        display: inline-block;
        padding: 4px 8px;
        margin-bottom: 8px;
        border-radius: var(
          --fg-borderradius--sm,
          var(--fg-fallback-borderradius--sm)
        );
        border: solid 1px var(--fg-error--dark, var(--fg-fallback-error--dark));
        color: var(--fg-error--dark, var(--fg-fallback-error--dark));
        background-color: var(
          ---fg-error--light,
          var(--fg-fallback-error--light)
        );
        line-height: 20px;
      }

      span svg {
        position: relative;
        top: 2px;
      }
    `,
  ];
}
